export const LOAD_USER_LIST = 'COMPANY:LOAD_USER_LIST';